import { useEffect, useState } from "react";
import Layout from '../../layout/default';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import { Button, Breadcrumb, Form } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { useApiClient } from "../../ApiService/useApiClient";
import { jsPDF } from "jspdf"; 
import autoTable from "jspdf-autotable"; 


export const MedicationHistoryReport = () => {


    const api = useApiClient();
    const [data, setData] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [params, setParams] = useState({
        CustomerID: '',
        FromDate: '',
        ToDate: '',
        MedicationName: '',
        TakenOrNot: ''
    });

    const columns = [
        {
            name: 'Date',
            selector: row => row.usageDate ? new Date(row.usageDate).toLocaleDateString() : '',
            sortable: true,
        },
        {
            name: 'Time',
            selector: row => row.usageDateTime ? new Date(row.usageDateTime).toLocaleTimeString() : '',
            sortable: false,
        },
        {
            name: 'Medication',
            selector: row => row.emarMedicationName || '',
            sortable: true,
        },
        {
            name: 'Dosage',
            selector: row => row.emarMedicationDosage || '',
            sortable: true,
        },
        {
            name: 'Taken',
            selector: row => row.takenOrNot || '',
            sortable: true,
        },
        {
            name: 'Usage Notes',
            selector: row => row.usageNotes || '',
            sortable: false,
        },
    ];

    useEffect(() => {
    api.get("HMCareData/customerlist/")
        .then(res => {
            setCustomerList(res.data);
        })
        .catch(err => {
            console.error("Error fetching customers", err);
        });
    }, []);

    const fetchData = () => {
        setError(null);
        setLoading(true);

        if (!params.CustomerID) {
            setError(new Error("Please enter a Customer ID."));
            setLoading(false);
            return;
        }

        const queryParams = {
            CustomerID: params.CustomerID,
            FromDate: params.FromDate,
            ToDate: params.ToDate,
            MedicationName: params.MedicationName,
            TakenOrNot: params.TakenOrNot
        };

        api.get(`HMCareTask/medicationhistory/${params.CustomerID}`, {
        startDate: params.FromDate || undefined,
        endDate: params.ToDate || undefined,
        medicationName: params.MedicationName || undefined,
        takenOrNot: params.TakenOrNot || undefined
    })
            .then((response) => {
                // Flattened data expected from API: header + usage combined
                const flatList = response.data.flatMap(h =>
                    h.medicationUsages.map(u => ({
                        ...u,
                        emarMedicationName: h.emarMedicationName,
                        emarMedicationDosage: h.emarMedicationDosage,
                        emarMedicationDesc: h.emarMedicationDesc
                    }))
                );
                setData(flatList);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
    };


//     const generatePDF = () => {
//     const doc = new jsPDF();

//     doc.setFontSize(18);
//     doc.text("Medication History Report", 14, 22);

//     const tableColumn = ["Date", "Time", "Medication", "Dosage", "Taken", "Usage Notes"];
//     const tableRows = data.map(row => [
//     row.usageDate ? new Date(row.usageDate).toLocaleDateString() : '',
//     row.usageDateTime ? new Date(row.usageDateTime).toLocaleTimeString() : '',
//     row.emarMedicationName || '',
//     row.emarMedicationDosage || '',
//     row.takenOrNot || '',
//     row.usageNotes || ''
//     ]);

//     autoTable(doc,{
//     head: [tableColumn],
//     body: tableRows,
//     startY: 35,
//     theme: 'striped',
//     styles: { fontSize: 10 },
//     });

//     doc.save("Medication_History_Report.pdf");
// };


const generatePDF = () => {
  const doc = new jsPDF();

  // Report title
  doc.setFontSize(18);
  doc.text("Medication History Report", 14, 22);

  // Get selected customer name
  const customer = customerList.find(c => c.customerid === params.CustomerID);
  const customerName = customer ? customer.name : "Unknown Customer";

  doc.setFontSize(12);
  doc.text(`Client: ${customerName}`, 14, 30);

  // Format date range if available
  let dateRangeText = "All Dates";
  if (params.FromDate && params.ToDate) {
    const fromDateFormatted = new Date(params.FromDate).toLocaleDateString();
    const toDateFormatted = new Date(params.ToDate).toLocaleDateString();
    dateRangeText = `From ${fromDateFormatted} to ${toDateFormatted}`;
  } else if (params.FromDate) {
    dateRangeText = `From ${new Date(params.FromDate).toLocaleDateString()}`;
  } else if (params.ToDate) {
    dateRangeText = `Up to ${new Date(params.ToDate).toLocaleDateString()}`;
  }

  doc.text(`Date Range: ${dateRangeText}`, 14, 38);

  // Report printed date (current date)
  const reportDate = new Date().toLocaleString();
  doc.text(`Report Date: ${reportDate}`, 14, 46);

  const tableColumn = ["Date", "Time", "Medication", "Dosage", "Taken", "Usage Notes"];
  const tableRows = data.map(row => [
    row.usageDate ? new Date(row.usageDate).toLocaleDateString() : '',
    row.usageDateTime ? new Date(row.usageDateTime).toLocaleTimeString() : '',
    row.emarMedicationName || '',
    row.emarMedicationDosage || '',
    row.takenOrNot || '',
    row.usageNotes || ''
  ]);

  // Add the table starting a bit lower to fit the header
  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 54,
    theme: 'striped',
    styles: { fontSize: 10 },
    didDrawPage: (data) => {
      // Add page number at the bottom center
      const pageCount = doc.internal.getNumberOfPages();
      const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
      const pageText = `Page ${pageNumber} of ${pageCount}`;
      doc.setFontSize(10);
      doc.text(pageText, doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 10, { align: 'center' });
    }
  });

  doc.save("Medication_History_Report.pdf");
};



    return (
        <Layout title="Medication History" content="container">
            <Breadcrumb className="breadcrumb-arrow">
                <Breadcrumb.Item><Link to={`/`}>Dashboard</Link></Breadcrumb.Item>
                <Breadcrumb.Item active>Medication History</Breadcrumb.Item>
            </Breadcrumb>

            <div style={{ padding: '20px' }}>
                <div
    style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '10px',
        alignItems: 'end',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        marginBottom: '20px',
        maxHeight: 'fit-content',
    }}
>
    <Form.Group controlId="CustomerID">
        <Form.Label>Customer</Form.Label>
        <Form.Select
            value={params.CustomerID}
            onChange={e => setParams(p => ({ ...p, CustomerID: e.target.value }))}
        >
            <option value="">Select Customer</option>
            {customerList.map(customer => (
                <option key={customer.customerid} value={customer.customerid}>
                    {customer.name}
                </option>
            ))}
        </Form.Select>
    </Form.Group>

    <Form.Group controlId="FromDate">
        <Form.Label>From</Form.Label>
        <Form.Control
            type="date"
            value={params.FromDate}
            onChange={e => setParams(p => ({ ...p, FromDate: e.target.value }))}
        />
    </Form.Group>

    <Form.Group controlId="ToDate">
        <Form.Label>To</Form.Label>
        <Form.Control
            type="date"
            value={params.ToDate}
            onChange={e => setParams(p => ({ ...p, ToDate: e.target.value }))}
        />
    </Form.Group>

    <Form.Group controlId="MedicationName">
        <Form.Label>Medication</Form.Label>
        <Form.Control
            type="text"
            placeholder="Medication Name"
            value={params.MedicationName}
            onChange={e => setParams(p => ({ ...p, MedicationName: e.target.value }))}
        />
    </Form.Group>

    <Form.Group controlId="TakenOrNot">
        <Form.Label>Taken?</Form.Label>
        <Form.Select
            value={params.TakenOrNot}
            onChange={e => setParams(p => ({ ...p, TakenOrNot: e.target.value }))}
        >
            <option value="">Taken or Not Taken</option>
            <option value="Taken">Yes</option>
            <option value="not taken">No</option>
        </Form.Select>
    </Form.Group>

    <div style={{ alignSelf: 'end' }}>
        <Button
            variant="outline-primary"
            onClick={fetchData}
            style={{ width: '100%' }}
            disabled={loading}
        >
            {loading ? "Running" : "Run Report"}
        </Button>
        </div>
    <div style={{ alignSelf: 'end' }}>
        <Button
            variant="outline-secondary"
            onClick={generatePDF}
            disabled={data.length === 0}
            style={{ height: '40px', minWidth: '150px' }}
            >
            Print Report
            </Button>

    </div>
</div>




                {error && (
                    <div className="alert alert-danger" role="alert" style={{ marginBottom: '15px' }}>
                        {error.message}
                    </div>
                )}

                {loading && <Spinner animation="border" variant="primary" />}

                {data && data.length > 0 && (
                    <DataTable
                        columns={columns}
                        data={data}
                        striped
                        pagination
                        highlightOnHover
                        dense
                    />
                )}
            </div>
        </Layout>
    );
};
